'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var EEScripts = function EEScripts() {
  var handleMainScriptLoaded = (0, _react.useCallback)(function () {
    EELayout.loadHeader(); // eslint-disable-line no-undef
    EELayout.loadFooter(); // eslint-disable-line no-undef
  }, []);

  (0, _react.useEffect)(function () {
    // eslint-disable-next-line prefer-destructuring
    var _window = window,
        EEContext = _window.EEContext;

    var cloudPath = EEContext.environment.isCloud ? '/extranet' : '';
    var baseUrl = EEContext.environment.baseCdnUrl + cloudPath;
    var src = baseUrl + '/scripts/eebundle/1/eebundle.min.js?version=' + EEContext.corpoContentVersion;

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.onload = handleMainScriptLoaded;
    document.head.appendChild(script);
  }, [handleMainScriptLoaded]);

  return null;
};

exports.default = EEScripts;